import { useRef as UseRef, useEffect, useState } from "react";
import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    Button,
    Box,
    Grid,
    Divider,
    TextField
} from "@mui/material";
import MenuApp from '../../../components/Menu';
import { ThemeProvider } from '@mui/material/styles';
import fix from "../../../services/fix"
import CssBaseline from '@mui/material/CssBaseline';
import constants from '../../../utils/constants';
import PriceCell from "../../../components/PriceCell";



const PriceBoard = () => {
    const [prices, setPrices] = useState([]);
    const [list, setList] = useState([]);
    const [code, setCode] = useState('');
    const [filtersValues, setFiltersValues] = useState([]);
    const boxRef = UseRef(null);
    const pricesRef = UseRef(prices);

    const title = ["Especie", "Vto.", "Moneda", "C.Cpra.", "P.Cpra.", "P.Vta.", "C.Vta.", "Apertura", "Mínimo", "Máximo", "Último", "Cierre Ant.", "Cierre", "Dir.", "Var.", "Volumen", "Vol.Monto", "Vwap", "Hora"]
    let fieldFilter = {};


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const ws = new WebSocket(constants.FIXMDSOCKET);

        ws.onmessage = (event) => {
            const updatedPrices = JSON.parse(event.data);
            orderFix(updatedPrices, pricesRef.current, ws);
        };

        ws.onerror = (error) => {
            console.error("WebSocket Error:", error);
        };

        return () => {
            ws.close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        pricesRef.current = prices;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prices]);

    const orderFix = (newPrice, pricesRef, ws) => {
        let arrayPrices = pricesRef;

        // Buscamos la tab que coincida con el nuevo precio
        //const priceTab = arrayPrices.find(p => p.nameTab === newPrice.nameTab);

        //if (priceTab) {
        //const subTab = priceTab.subTabs.find(sub => sub.nameSubTab === (newPrice.nameSubTab || ""));
        //if (subTab) {

        // Iteramos sobre NoMDEntries
        let shouldUpdatePrices = false;

        newPrice.NoMDEntries.forEach(newEntry => {
            const mDEntryType = newEntry.MDEntryType;

            // Filtramos precios según el tipo de MDEntryType
            if (['0', '1'].includes(mDEntryType)) {
                newEntry.priceList.forEach(priceListItem => {
                    const securityIdNewPrice = priceListItem.SecurityID;
                    const species = arrayPrices.find(species => species.SecurityID === securityIdNewPrice);

                    if (species) {
                        const existingEntry = species.NoMDEntries.find(entry => entry.MDEntryType === mDEntryType);
                        const positionDelete = priceListItem.MDEntryPositionNo;
                        species.time = new Date().toLocaleTimeString();
                        species.lastMdEntryPx = priceListItem.MDEntryPx;
                        if (existingEntry) {
                            switch (newEntry.MDUpdateAction) {
                                case 0: // Insert
                                    // Insert new price entry and adjust positions
                                    let newPriceEntry = { ...priceListItem };
                                    existingEntry.priceList.push(newPriceEntry);
                                    existingEntry.priceList.sort((a, b) => a.MDEntryPositionNo - b.MDEntryPositionNo);
                                    if (priceListItem.MDEntryPositionNo === 1) shouldUpdatePrices = true;
                                    break;
                                case 2: // Delete
                                    // Delete price entry and adjust positions
                                    const initialLength = existingEntry.priceList.length;
                                    existingEntry.priceList = existingEntry.priceList.filter(entry => entry.MDEntryPositionNo !== positionDelete);
                                    if (initialLength !== existingEntry.priceList.length && positionDelete === 1) {
                                        shouldUpdatePrices = true;
                                    }
                                    existingEntry.priceList.forEach((entry, index) => {
                                        if (entry.MDEntryPositionNo > positionDelete) {
                                            entry.MDEntryPositionNo -= 1;
                                        }
                                    });
                                    break;
                                case 1: // Update
                                    // Update the price entry
                                    const entryToUpdate = existingEntry.priceList.find(entry => entry.MDEntryPositionNo === priceListItem.MDEntryPositionNo);
                                    if (entryToUpdate) {
                                        entryToUpdate.previousMDEntryPx = entryToUpdate.MDEntryPx;
                                        entryToUpdate.previousMDEntrySize = entryToUpdate.MDEntrySize;
                                        Object.assign(entryToUpdate, priceListItem);
                                        if (priceListItem.MDEntryPositionNo === 1) shouldUpdatePrices = true;
                                    }
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            // Create a new NoMDEntry if it does not exist
                            if (newEntry.MDUpdateAction === 0) {
                                const newGroup = {
                                    MDEntryType: mDEntryType,
                                    MDUpdateAction: newEntry.MDUpdateAction,
                                    priceList: newEntry.priceList.map(item => ({ ...item }))
                                };
                                species.NoMDEntries.push(newGroup);
                                shouldUpdatePrices = true;
                            }
                        }
                    }
                });
            } else {
                // Handle other MDEntryTypes
                const species = arrayPrices.find(species => species.SecurityID === newEntry.SecurityID);
                if (species) {
                    species.time = new Date().toLocaleTimeString();
                    const existingEntry = species.NoMDEntries.find(entry => entry.MDEntryType === mDEntryType);
                    if (existingEntry) {
                        existingEntry.previousMDEntryPx = existingEntry.MDEntryPx;
                        existingEntry.previousMDEntrySize = existingEntry.MDEntrySize;
                        Object.assign(existingEntry, newEntry);
                    } else {
                        species.NoMDEntries.push({ ...newEntry });
                    }
                    shouldUpdatePrices = true;
                }
            }
        });
        if (shouldUpdatePrices) {
            setPrices([...arrayPrices]);
        }
        //}
        //}
    };

    /*const viewPrice = (securityType) => {
        setSelectedCode(securityType);
        pricesRef.current = [];
        fix.prices(securityType).then((response) => {
            let pricesResponse = response.data;
            for (let p = 0; p < pricesResponse.length; p++) {
                for (let a = 0; a < pricesResponse[p].subTabs.length; a++) {
                    for (let b = 0; b < pricesResponse[p].subTabs[a].especies.length; b++) {
                        pricesResponse[p].subTabs[a].especies[b].time = new Date().toLocaleTimeString();
                    }
                }
            }

            setPrices(pricesResponse);
            setList(pricesResponse);
            let cantSubTabs = [];
            for (let p = 0; p < pricesResponse.length; p++) {
                for (let t = 0; t < pricesResponse[p].subTabs.length; t++) {
                    cantSubTabs.push(true);
                }
            }
            setCollapsedStates(cantSubTabs);
        })
    }*/

    const viewPrice = (securityType, boxs,cod) => {
        setPrices([]);
        pricesRef.current = [];
        setCode(cod);
        fix.prices(securityType).then((response) => {
            const pricesResponse = response.data;
            let prices = [];
            for (let p = 0; p < pricesResponse.length; p++) {
                for (let a = 0; a < pricesResponse[p].subTabs.length; a++) {
                    for (let a1 = 0; a1 < boxs.length; a1++) {
                        if (boxs[a1] === pricesResponse[p].subTabs[a].nameSubTab) {
                            for (let b = 0; b < pricesResponse[p].subTabs[a].especies.length; b++) {
                                let especie = pricesResponse[p].subTabs[a].especies[b];
                                especie.time = new Date().toLocaleTimeString();
                                prices.push(especie);
                            }
                        }
                    }
                }
            }

            setPrices(prices);
            setList(prices);

        })
    }


    const handleFieldFilterChange = (e, idField) => {
        let value = e.target.value;
        fieldFilter = {
            id: value
        }

        let newFiltersValues = filtersValues.filter(filter => filter.idField !== idField);

        if (value !== "") {
            newFiltersValues = [...newFiltersValues, { idField, value }];
        }
        setFiltersValues(newFiltersValues);

        const updatedFiltersValues = [...newFiltersValues];

        if (updatedFiltersValues.length > 0) {
            let pricesFlag = JSON.parse(JSON.stringify(list));
            for (let r = 0; r < list.length; r++) {
                let especies = [];
                for (let r = 0; r < list.length; r++) {
                    let matchesAllFilters = true;
                    for (let h = 0; h < updatedFiltersValues.length; h++) {

                        if (updatedFiltersValues[h].idField === 'SettlType') {
                            let valueEspecie = '24hs';
                            let SettlTypeFlag = list[r].NoMDEntries[0].SettlType;
                            if (Number(SettlTypeFlag) === 2) {
                                valueEspecie = '48hs';
                            }
                            if (!valueEspecie.includes(updatedFiltersValues[h].value.toUpperCase())) {
                                matchesAllFilters = false;
                                break;
                            }
                        } else {

                            if (list[r][updatedFiltersValues[h].idField]) {

                                let valueEspecie = list[r][updatedFiltersValues[h].idField].toUpperCase();
                                if (updatedFiltersValues[h].idField === 'SecurityID') {
                                    valueEspecie = '-';
                                    let sec = list[r].SecurityID.split('-');
                                    if (sec.length > 3) {
                                        valueEspecie = sec[4];
                                    }
                                }

                                if (!valueEspecie.includes(updatedFiltersValues[h].value.toUpperCase())) {
                                    matchesAllFilters = false;
                                    break;
                                }

                            } else {
                                matchesAllFilters = false;
                                break;
                            }
                        }
                    }
                    if (matchesAllFilters) {
                        especies.push(list[r])
                    }
                }
                pricesFlag = especies;
            }
            setPrices(pricesFlag);
        } else {
            let arrayFlag = [];
            for (let r = 0; r < list.length; r++) {
                arrayFlag.push(list[r]);
            }
            setPrices(arrayFlag);
        }
    }

    const formatNumber = (value) => {
        if (value == null || isNaN(value)) return '-';

        const [integerPart, decimalPart = ''] = value.toString().split('.');
        const withThousands = Number(integerPart).toLocaleString('de-DE'); // separador miles con punto

        let formattedDecimals;
        if (decimalPart.length === 0) {
            formattedDecimals = '00';
        } else if (decimalPart.length === 1) {
            formattedDecimals = `${decimalPart}0`;
        } else {
            formattedDecimals = decimalPart;
        }

        return `${withThousands},${formattedDecimals}`;
    };

    return (
        <ThemeProvider theme={constants.CUSTOM_MUI_GENERAL_THEME}>
            <div className="App">
                <CssBaseline />
                <header className="App-header">
                    <Box ref={boxRef} sx={{ width: "100%", flexGrow: 1 }}>
                        <Grid container xs={12} item>
                            <Grid container sx={{ m: 1 }} xs={12} item>
                                <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                    <Box sx={{ width: '100%' }}>
                                        <MenuApp />
                                        <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                                            <Typography
                                                sx={{
                                                    mt: 4,
                                                    mb: 2,
                                                }}
                                                variant="h6"
                                                component="div"
                                            >
                                                Tablero de Precios
                                            </Typography>
                                            <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    gap: 1
                                                }}
                                            >
                                                <Button
                                                    color="primary"
                                                    variant={code === 'CS' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('CS', ['Merval-Lideres'],'CS')}
                                                >
                                                    Líderes
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'CS1' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('CS', ['General', ''],'CS1')}
                                                >
                                                    General
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'OPT' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('OPT', [''],'OPT')}
                                                >
                                                    Opciones
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'CD' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('CD', [''],'CD')}
                                                >
                                                    Cedears
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'GO' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('GO', [''],'GO')}
                                                >
                                                    Bonos
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'GO1' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('GO', ['Letes'],'GO1')}
                                                >
                                                    Letras
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'CORP' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('CORP', ['Oblig. Negociables Cortas', ''],'CORP')}
                                                >
                                                    ONs
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'QS' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('QS', [''],'QS')}
                                                >
                                                    Cauciones
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'FUT' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('FUT', ['Indice Merval'],'FUT')}
                                                >
                                                    Índices
                                                </Button>

                                                <Button
                                                    color="primary"
                                                    variant={code === 'FUT1' ? 'contained' : 'outlined'}
                                                    sx={{ height: 32, minWidth: 50 }}
                                                    onClick={() => viewPrice('FUT', ['Dólar', 'Dólar pase', 'Real'],'FUT1')}
                                                >
                                                    Futuros
                                                </Button>
                                            </Box>

                                            <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                                                <TableContainer component={Paper} sx={{
                                                    maxWidth: "auto",
                                                    margin: "auto",
                                                    //mt: 4,
                                                    maxHeight: "auto", // Altura máxima
                                                    overflowY: "auto" // Habilita el scroll vertical
                                                }}>

                                                    <Table>
                                                        <TableHead
                                                            sx={{
                                                                position: "sticky",
                                                                top: 0,
                                                                backgroundColor: "white",
                                                                zIndex: 2 // Asegura que el encabezado se mantenga sobre las filas
                                                            }}
                                                        >
                                                            <TableRow>
                                                                <TableCell >
                                                                    <TextField
                                                                        value={fieldFilter.Symbol}
                                                                        onChange={(event) => handleFieldFilterChange(event, `Symbol`)}
                                                                        InputProps={{
                                                                            style: {
                                                                                height: '30px',
                                                                                fontSize: "inherit", lineHeight: "inherit"
                                                                            }
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell >
                                                                    <TextField
                                                                        value={fieldFilter.setType}
                                                                        onChange={(event) => handleFieldFilterChange(event, `SettlType`)}
                                                                        InputProps={{
                                                                            style: {
                                                                                height: '30px',
                                                                                fontSize: "inherit", lineHeight: "inherit"
                                                                            }
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell >
                                                                    <TextField
                                                                        value={fieldFilter.currency}
                                                                        onChange={(event) => handleFieldFilterChange(event, `SecurityID`)}
                                                                        InputProps={{
                                                                            style: {
                                                                                height: '30px',
                                                                                fontSize: "inherit", lineHeight: "inherit"
                                                                            }
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                            <TableRow sx={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: 'rgb(50 59 152)' }}>
                                                                {
                                                                    title.map((title) => (
                                                                        <TableCell style={{ color: 'white' }}><b>{title}</b></TableCell>
                                                                    ))
                                                                }
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                prices.map((item, index) => {

                                                                    let currency = '-';
                                                                    let sec = item.SecurityID.split('-');
                                                                    if (sec.length > 3) {
                                                                        currency = sec[4];
                                                                    }

                                                                    let vto = '-';
                                                                    let setType = item.NoMDEntries[0].SettlType;
                                                                    if (setType === 1)
                                                                        vto = "24hs";
                                                                    if (setType === 2)
                                                                        vto = "48hs";

                                                                    const mdEntry = item.NoMDEntries.find((e) => e.MDEntryType === '1');
                                                                    const previousMDEntrySize = mdEntry?.priceList?.[0]?.previousMDEntrySize ?? null;
                                                                    const MDEntrySize = mdEntry?.priceList?.[0]?.MDEntrySize ?? null;

                                                                    const previousMDEntryPx = mdEntry?.priceList?.[0]?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx = mdEntry?.priceList?.[0]?.MDEntryPx ?? null;

                                                                    const mdEntry0 = item.NoMDEntries.find((e) => e.MDEntryType === '0');
                                                                    const previousMDEntryPx0 = mdEntry0?.priceList?.[0]?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx0 = mdEntry0?.priceList?.[0]?.MDEntryPx ?? null;

                                                                    const previousMDEntrySize0 = mdEntry0?.priceList?.[0]?.previousMDEntrySize ?? null;
                                                                    const MDEntrySize0 = mdEntry0?.priceList?.[0]?.MDEntrySize ?? null;

                                                                    const mdEntry4 = item.NoMDEntries.find((e) => e.MDEntryType === '4');
                                                                    const previousMDEntryPx4 = mdEntry4?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx4 = mdEntry4?.MDEntryPx ?? null;

                                                                    const mdEntry8 = item.NoMDEntries.find((e) => e.MDEntryType === '8');
                                                                    const previousMDEntryPx8 = mdEntry8?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx8 = mdEntry8?.MDEntryPx ?? null;

                                                                    const mdEntry7 = item.NoMDEntries.find((e) => e.MDEntryType === '7');
                                                                    const previousMDEntryPx7 = mdEntry7?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx7 = mdEntry7?.MDEntryPx ?? null;

                                                                    const mdEntrye = item.NoMDEntries.find((e) => e.MDEntryType === 'e');
                                                                    const previousMDEntryPxe = mdEntrye?.previousMDEntryPx ?? null;
                                                                    const MDEntryPxe = mdEntrye?.MDEntryPx ?? null;

                                                                    const mdEntry5 = item.NoMDEntries.find((e) => e.MDEntryType === '5');
                                                                    const previousMDEntryPx5 = mdEntry5?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx5 = mdEntry5?.MDEntryPx ?? null;

                                                                    const mdEntryB = item.NoMDEntries.find((e) => e.MDEntryType === 'B');
                                                                    const previousMDEntrySizeB = mdEntryB?.previousMDEntrySize ?? null;
                                                                    const MDEntrySizeB = mdEntryB?.MDEntrySize ?? null;

                                                                    const previousMDEntryPxB = mdEntryB?.previousMDEntryPx ?? null;
                                                                    const MDEntryPxB = mdEntryB?.MDEntryPx ?? null;

                                                                    const mdEntry9 = item.NoMDEntries.find((e) => e.MDEntryType === '9');
                                                                    const previousMDEntryPx9 = mdEntry9?.previousMDEntryPx ?? null;
                                                                    const MDEntryPx9 = mdEntry9?.MDEntryPx ?? null;

                                                                    return <TableRow key={index}>
                                                                        <TableCell>{item.Symbol}</TableCell>
                                                                        <TableCell>{vto}</TableCell>
                                                                        <TableCell>{currency}</TableCell>
                                                                        <PriceCell previousSize={previousMDEntrySize} currentSize={MDEntrySize} />
                                                                        <PriceCell previousSize={previousMDEntryPx} currentSize={MDEntryPx} />
                                                                        <PriceCell previousSize={previousMDEntryPx0} currentSize={MDEntryPx0} />
                                                                        <PriceCell previousSize={previousMDEntrySize0} currentSize={MDEntrySize0} />
                                                                        <PriceCell previousSize={previousMDEntryPx4} currentSize={MDEntryPx4} />
                                                                        <PriceCell previousSize={previousMDEntryPx8} currentSize={MDEntryPx8} />
                                                                        <PriceCell previousSize={previousMDEntryPx7} currentSize={MDEntryPx7} />
                                                                        <TableCell style={{ textAlign: 'right' }}>{formatNumber(item.lastMdEntryPx)}</TableCell>
                                                                        <PriceCell previousSize={previousMDEntryPxe} currentSize={MDEntryPxe} />
                                                                        <PriceCell previousSize={previousMDEntryPx5} currentSize={MDEntryPx5} />
                                                                        <TableCell style={{ textAlign: 'right' }}>-</TableCell>
                                                                        <TableCell style={{ textAlign: 'right' }}>{item.lastMdEntryPx && item.NoMDEntries.find((e) => e.MDEntryType === '5')?.MDEntryPx ? formatNumber(((Number(item.NoMDEntries.find((e) => e.MDEntryType === '5')?.MDEntryPx) / Number(item.lastMdEntryPx)).toFixed(2))) : ''}%
                                                                        </TableCell>
                                                                        <PriceCell previousSize={previousMDEntrySizeB} currentSize={MDEntrySizeB} />
                                                                        <PriceCell previousSize={previousMDEntryPxB} currentSize={MDEntryPxB} />
                                                                        <PriceCell previousSize={previousMDEntryPx9} currentSize={MDEntryPx9} />

                                                                        {<TableCell>{item.time}</TableCell>}
                                                                    </TableRow>
                                                                })

                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                            </Box>



                                            {/*prices[0].subTabs.map((item, index) => {
                                                        return <Box key={`box-${index}`} border={1} borderColor="rgb(216, 216, 216)" borderRadius="4px" p={2} padding={1}>
                                                            <Box display="flex" alignItems="center">
                                                                <IconButton onClick={() => handleToggleCollapse(index)}>
                                                                    {collapsedStates[index] ? (<ExpandMoreIcon />) : (<ExpandLessIcon />)}
                                                                </IconButton>
                                                                <TypographyComponent
                                                                    paragraphType='body1'
                                                                    text={item.nameSubTab}
                                                                />
                                                            </Box>
                                                            {!collapsedStates[index] && (
                                                                <TableContainer component={Paper} sx={{
                                                                    maxWidth: "auto",
                                                                    margin: "auto",
                                                                    mt: 4,
                                                                    maxHeight: 400, // Altura máxima
                                                                    overflowY: "auto" // Habilita el scroll vertical
                                                                }}>

                                                                    <Table>
                                                                        <TableHead
                                                                            sx={{
                                                                                position: "sticky",
                                                                                top: 0,
                                                                                backgroundColor: "white",
                                                                                zIndex: 2 // Asegura que el encabezado se mantenga sobre las filas
                                                                            }}
                                                                        >

                                                                            <TableRow>
                                                                                <TableCell >
                                                                                    <TextField
                                                                                        value={fieldFilter.Symbol}
                                                                                        onChange={(event) => handleFieldFilterChange(event, `Symbol`, item.nameSubTab)}
                                                                                        InputProps={{
                                                                                            style: {
                                                                                                height: '30px',
                                                                                                fontSize: "inherit", lineHeight: "inherit"
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell >
                                                                                    <TextField
                                                                                        value={fieldFilter.setType}
                                                                                        onChange={(event) => handleFieldFilterChange(event, `SettlType`, item.nameSubTab)}
                                                                                        InputProps={{
                                                                                            style: {
                                                                                                height: '30px',
                                                                                                fontSize: "inherit", lineHeight: "inherit"
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell >
                                                                                    <TextField
                                                                                        value={fieldFilter.currency}
                                                                                        onChange={(event) => handleFieldFilterChange(event, `SecurityID`, item.nameSubTab)}
                                                                                        InputProps={{
                                                                                            style: {
                                                                                                height: '30px',
                                                                                                fontSize: "inherit", lineHeight: "inherit"
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                                <TableCell></TableCell>
                                                                            </TableRow>


                                                                            <TableRow>
                                                                                {
                                                                                    title.map((title) => (
                                                                                        <TableCell><b>{title}</b></TableCell>
                                                                                    ))
                                                                                }
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {
                                                                                item.especies.map((item, index) => {

                                                                                    let currency = '-';
                                                                                    let sec = item.SecurityID.split('-');
                                                                                    if (sec.length > 3) {
                                                                                        currency = sec[4];
                                                                                    }

                                                                                    let vto = '-';
                                                                                    let setType = item.NoMDEntries[0].SettlType;
                                                                                    if (setType === 1)
                                                                                        vto = "24hs";
                                                                                    if (setType === 2)
                                                                                        vto = "48hs";

                                                                                    const mdEntry = item.NoMDEntries.find((e) => e.MDEntryType === '1');
                                                                                    const previousMDEntrySize = mdEntry?.priceList?.[0]?.previousMDEntrySize ?? null;
                                                                                    const MDEntrySize = mdEntry?.priceList?.[0]?.MDEntrySize ?? null;

                                                                                    const previousMDEntryPx = mdEntry?.priceList?.[0]?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx = mdEntry?.priceList?.[0]?.MDEntryPx ?? null;

                                                                                    const mdEntry0 = item.NoMDEntries.find((e) => e.MDEntryType === '0');
                                                                                    const previousMDEntryPx0 = mdEntry0?.priceList?.[0]?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx0 = mdEntry0?.priceList?.[0]?.MDEntryPx ?? null;

                                                                                    const previousMDEntrySize0 = mdEntry0?.priceList?.[0]?.previousMDEntrySize ?? null;
                                                                                    const MDEntrySize0 = mdEntry0?.priceList?.[0]?.MDEntrySize ?? null;

                                                                                    const mdEntry4 = item.NoMDEntries.find((e) => e.MDEntryType === '4');
                                                                                    const previousMDEntryPx4 = mdEntry4?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx4 = mdEntry4?.MDEntryPx ?? null;

                                                                                    const mdEntry8 = item.NoMDEntries.find((e) => e.MDEntryType === '8');
                                                                                    const previousMDEntryPx8 = mdEntry8?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx8 = mdEntry8?.MDEntryPx ?? null;

                                                                                    const mdEntry7 = item.NoMDEntries.find((e) => e.MDEntryType === '7');
                                                                                    const previousMDEntryPx7 = mdEntry7?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx7 = mdEntry7?.MDEntryPx ?? null;

                                                                                    const mdEntrye = item.NoMDEntries.find((e) => e.MDEntryType === 'e');
                                                                                    const previousMDEntryPxe = mdEntrye?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPxe = mdEntrye?.MDEntryPx ?? null;

                                                                                    const mdEntry5 = item.NoMDEntries.find((e) => e.MDEntryType === '5');
                                                                                    const previousMDEntryPx5 = mdEntry5?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx5 = mdEntry5?.MDEntryPx ?? null;

                                                                                    const mdEntryB = item.NoMDEntries.find((e) => e.MDEntryType === 'B');
                                                                                    const previousMDEntrySizeB = mdEntryB?.previousMDEntrySize ?? null;
                                                                                    const MDEntrySizeB = mdEntryB?.MDEntrySize ?? null;

                                                                                    const previousMDEntryPxB = mdEntryB?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPxB = mdEntryB?.MDEntryPx ?? null;

                                                                                    const mdEntry9 = item.NoMDEntries.find((e) => e.MDEntryType === '9');
                                                                                    const previousMDEntryPx9 = mdEntry9?.previousMDEntryPx ?? null;
                                                                                    const MDEntryPx9 = mdEntry9?.MDEntryPx ?? null;

                                                                                    return <TableRow key={index}>
                                                                                        <TableCell>{item.Symbol}</TableCell>
                                                                                        <TableCell>{vto}</TableCell>
                                                                                        <TableCell>{currency}</TableCell>
                                                                                        <PriceCell previousSize={previousMDEntrySize} currentSize={MDEntrySize} />
                                                                                        <PriceCell previousSize={previousMDEntryPx} currentSize={MDEntryPx} />
                                                                                        <PriceCell previousSize={previousMDEntryPx0} currentSize={MDEntryPx0} />
                                                                                        <PriceCell previousSize={previousMDEntrySize0} currentSize={MDEntrySize0} />
                                                                                        <PriceCell previousSize={previousMDEntryPx4} currentSize={MDEntryPx4} />
                                                                                        <PriceCell previousSize={previousMDEntryPx8} currentSize={MDEntryPx8} />
                                                                                        <PriceCell previousSize={previousMDEntryPx7} currentSize={MDEntryPx7} />
                                                                                        <TableCell style={{ textAlign: 'right' }}>{formatNumber(item.lastMdEntryPx)}</TableCell>
                                                                                        <PriceCell previousSize={previousMDEntryPxe} currentSize={MDEntryPxe} />
                                                                                        <PriceCell previousSize={previousMDEntryPx5} currentSize={MDEntryPx5} />
                                                                                        <TableCell style={{ textAlign: 'right' }}>-</TableCell>
                                                                                        <TableCell style={{ textAlign: 'right' }}>{item.lastMdEntryPx && item.NoMDEntries.find((e) => e.MDEntryType === '5')?.MDEntryPx ? formatNumber(((Number(item.NoMDEntries.find((e) => e.MDEntryType === '5')?.MDEntryPx) / Number(item.lastMdEntryPx)).toFixed(2))) : ''}%
                                                                                        </TableCell>
                                                                                        <PriceCell previousSize={previousMDEntrySizeB} currentSize={MDEntrySizeB} />
                                                                                        <PriceCell previousSize={previousMDEntryPxB} currentSize={MDEntryPxB} />
                                                                                        <PriceCell previousSize={previousMDEntryPx9} currentSize={MDEntryPx9} />

                                                                                        {<TableCell>{item.time}</TableCell>}
                                                                                    </TableRow>
                                                                                })

                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            )}
                                                        </Box>
                                                    })*/
                                            }



                                        </Box>
                                    </Box>
                                </ThemeProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </header>
            </div>
        </ThemeProvider>
    );
};

export default PriceBoard;
